module.exports = __webpack_public_path__ + "static/media/AtribuirUser.02cdd50a.svg";